module.exports = __webpack_public_path__ + "img/Frame_StageFrame_n_Yellow.45996f86.png";